/*
 * Product page: no size is preselected when the URL has no ?variant=.
 * Liquid (product-size-gate, product-variant-picker, product-buttons) renders the initial state and sets
 * data-size-required on <variant-selects> / <product-form>. This file keeps the add-to-cart button disabled
 * (with the "select a size" hint), hides dynamic checkout and blocks form submit until a size is chosen.
 */
(function () {
  if (window.theme && window.theme.sizeGate) return;
  window.theme = window.theme || {};

  var decoder = document.createElement('textarea');
  function decode(value) {
    decoder.innerHTML = value;
    return decoder.value;
  }

  function lock(form) {
    var hint = form.dataset.selectSizeText;
    var idInput = form.querySelector('[name=id]');
    if (idInput) {
      idInput.value = '';
      idInput.disabled = true;
    }
    if (typeof form.toggleSubmitButton === 'function' && hint) {
      form.toggleSubmitButton(true, hint);
    } else {
      var button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('disabled', 'disabled');
    }
    form.querySelectorAll('[data-size-gate-checkout]').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function unlock(form) {
    var idInput = form.querySelector('[name=id]');
    if (idInput) idInput.disabled = false;
    form.querySelectorAll('[data-size-gate-checkout]').forEach(function (el) {
      el.style.display = '';
    });
  }

  window.theme.sizeGate = {
    isRequired: function (doc) {
      return !!(doc && doc.querySelector('variant-selects[data-size-required="true"]'));
    },

    // Called from product-info after every option change with the re-rendered document.
    apply: function (info, doc) {
      var form = info.querySelector('product-form');
      if (!form) return;
      if (this.isRequired(doc)) {
        form.setAttribute('data-size-required', 'true');
        lock(form);
      } else if (form.hasAttribute('data-size-required')) {
        form.removeAttribute('data-size-required');
        unlock(form);
      }
    },

    // Adds variant=<id> to the section request once every option has a value, so the server
    // renders the chosen size as selected (product.selected_variant is set by that parameter).
    addVariantParam: function (info, url, params) {
      if (url !== info.dataset.url) return;
      var selects = info.querySelector('variant-selects');
      var mapEl = selects && selects.querySelector('[data-variants-map]');
      if (!mapEl) return;
      var wrappers = selects.querySelectorAll('[data-option-position]');
      var chosen = [];
      for (var i = 0; i < wrappers.length; i++) {
        var radio = wrappers[i].querySelector('input[type="radio"]:checked');
        var popout = wrappers[i].querySelector('[data-popout-input]');
        var value = radio ? radio.value : popout ? popout.value : '';
        if (!value) return;
        chosen[Number(wrappers[i].getAttribute('data-option-position')) - 1] = decode(value);
      }
      var variants;
      try {
        variants = JSON.parse(mapEl.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(variants)) {
        if (variants && Array.isArray(variants.variants)) variants = variants.variants;
        else return;
      }
      for (var v = 0; v < variants.length; v++) {
        if (!variants[v] || !Array.isArray(variants[v].options)) continue;
        var options = variants[v].options;
        var match = options.length === chosen.length && options.every(function (o, idx) {
          return o === chosen[idx];
        });
        if (match) {
          params.push('variant=' + variants[v].id);
          return;
        }
      }
    },
  };

  // Submit guard: Enter key, cart bar button or any other path to the product form.
  document.addEventListener(
    'submit',
    function (event) {
      if (event.target.closest && event.target.closest('product-form[data-size-required="true"]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  customElements.whenDefined('product-form').then(function () {
    var proto = customElements.get('product-form').prototype;
    var original = proto.onSubmitHandler;
    if (original && !proto.__sizeGatePatched) {
      proto.__sizeGatePatched = true;
      proto.onSubmitHandler = function (event) {
        if (this.getAttribute('data-size-required') === 'true') {
          if (event && event.preventDefault) event.preventDefault();
          var section = this.closest('product-info');
          if (section) {
            section.querySelectorAll('[data-cart-bar-add-to-cart]').forEach(function (el) {
              el.classList.remove('is-loading');
              el.removeAttribute('disabled');
            });
            var selects = section.querySelector('variant-selects');
            if (selects && selects.scrollIntoView) selects.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
        return original.apply(this, arguments);
      };
    }
    // product-form's constructor re-enables the id input; keep it off while no size is chosen.
    document.querySelectorAll('product-form[data-size-required="true"]').forEach(lock);
  });
})();
